<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('getInoutInfo.queryTitle') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="getInoutInfoManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-date-picker v-model="getInoutInfoManageInfo.conditions.beginTime" type="datetime"
              :placeholder="$t('getInoutInfo.startTime')" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="getInoutInfoManageInfo.conditions.endTime" type="datetime"
              :placeholder="$t('getInoutInfo.endTime')" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="getInoutInfoManageInfo.conditions.prodNameLike"
              :placeholder="$t('getInoutInfo.productName')" />

          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryGetInoutInfoMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetGetInoutInfoMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('getInoutInfo.listTitle') }}</div>
      </div>
      <div class="">
        <el-table :data="getInoutInfoManageInfo.getInoutInfos" border style="width: 100%">
          <el-table-column prop="barCode" :label="$t('getInoutInfo.barCode')" align="center" />
          <el-table-column prop="prodName" :label="$t('getInoutInfo.prodName')" align="center" />
          <el-table-column prop="specName" :label="$t('getInoutInfo.specName')" align="center" />
          <el-table-column prop="prodCount" :label="$t('getInoutInfo.prodCount')" align="center" />
          <el-table-column prop="actCount" :label="$t('getInoutInfo.actCount')" align="center" />
          <el-table-column prop="price" :label="$t('getInoutInfo.price')" align="center" />
          <el-table-column prop="unitName" :label="$t('getInoutInfo.unitName')" align="center" />
          <el-table-column prop="amount" :label="$t('getInoutInfo.amount')" align="center" />
          <el-table-column prop="tActCount" :label="$t('getInoutInfo.tActCount')" align="center" />
          <el-table-column prop="tAmount" :label="$t('getInoutInfo.tAmount')" align="center" />
          <el-table-column prop="createTime" :label="$t('getInoutInfo.createTime')" align="center" />
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next" :total="getInoutInfoManageInfo.total"
          style="margin-top: 20px; text-align: right">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getInoutInfoList } from '@/api/goods/getInoutInfoApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GetInoutInfoManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      getInoutInfoManageInfo: {
        getInoutInfos: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          beginTime: '',
          endTime: '',
          prodNameLike: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.getInoutInfoManageInfo.conditions.shopId = getShopId()
    this._listGetInoutInfos(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listGetInoutInfos(val, this.DEFAULT_ROWS)
    },
    async _listGetInoutInfos(_page, _rows) {
      this.getInoutInfoManageInfo.conditions.page = _page
      this.getInoutInfoManageInfo.conditions.row = _rows
      const param = {
        params: this.getInoutInfoManageInfo.conditions
      }
      param.params.prodNameLike = param.params.prodNameLike.trim()

      try {
        const res = await getInoutInfoList(param.params)
        this.getInoutInfoManageInfo.total = res.total
        this.getInoutInfoManageInfo.records = res.records
        this.getInoutInfoManageInfo.getInoutInfos = res.data
        this.currentPage = _page
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _queryGetInoutInfoMethod() {
      this._listGetInoutInfos(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetGetInoutInfoMethod() {
      this.getInoutInfoManageInfo.conditions = {
        beginTime: '',
        endTime: '',
        prodNameLike: '',
        shopId: getShopId()
      }
      this._listGetInoutInfos(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
</style>